import { createDialogQueue } from "@rmwc/dialog";

export const dialogQueue = createDialogQueue();
